<template lang="pug">
div
  el-form-item(label="计算公式")
    div(class="curComputationalFormula" @click="showComputationalFormulaDialog")
      span(v-for="(operate, index) in computationalFormula", :key="index") {{ operate ? operate.value : ''}}
  el-form-item(label="精度")
    el-input-number(v-model="jyhtPrecision")
  el-form-item(label="显示千分位")
    el-switch(v-model="thousandSeparator")
  el-form-item(label="显示百分比")
    el-switch(v-model="displayPercent")
  el-form-item(label="显示大写")
    el-switch(v-model="displayUppercase")
  el-form-item(label="前缀文字")
    el-input(v-model="prefixText")
  el-form-item(label="后缀文字")
    el-input(v-model="suffixText")
  el-form-item(label="内容对齐")
    el-radio-group(v-model="contentAlign" class='radio-group-custom')
      el-radio-button(label="left") 居左
      el-radio-button(label="center") 居中
      el-radio-button(label="right") 居右
  el-dialog(width="910px", title="计算公式", :visible.sync="visibleComputationalFormulaDialog", :close-on-click-modal="false" append-to-body)
    .top(ref="top")
      .equalSign =
      div(class="input" contenteditable="true" ref="input" @input="updateValue($event)") {{ inputValue }}
      .mask
        span(v-for="(operate, id) in curComputationalFormula",
       :class='[operate.type === "field" ? !operate.isMianTable ?"green" :"blue": ""]' :key="id") {{ operate ? operate.value : '' }}
      .operate
        el-button(type="text" @click="backspace") 退格
        el-button(type="text" @click="empty") 清空
    .bottom
      .left
        el-input(v-model="searchVal" placeholder="请输入内容")
        el-select(v-model="tableName", @change="tableChange" style='margin-top: 10px; width: 100%')
          el-option(v-for="(val, id ) in tableList", :key="val.name", :value="val.name", :label="val.label")
        .tableFieldList
          div(v-for="(val, id ) in finalTableFieldList", :key="id" class='field' @click="fieldAction(val)") {{val.label}}
      <Calculator @action="action"/>
    template(#footer)
      el-button(@click="close()") 取消
      el-button(type="primary", @click="submit()") 提交
</template>

<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import Calculator from "./Calculator.vue";
import { cloneDeep } from "lodash";
import metadataService from "@/CommonDP/service/metadata-service.js";
export default {
  components: {
    Calculator
  },
  mixins: [settingMixin],
  inject: ["setFieldList", "getGlobalDsv"],
  props: {
    optionModel: Object
  },
  data() {
    return {
      visibleComputationalFormulaDialog: false,
      curComputationalFormula: [],
      searchVal: "",
      tableName: "",
      subformList: [],
      tableFieldList: [],
      allSubformList: {},
      activeTableName: ""
    };
  },
  computed: {
    ...mapVFOptions("computationalFormula", "jyhtPrecision", "thousandSeparator", "displayPercent", "displayUppercase", "suffixText", "prefixText", "contentAlign", "name"),
    formId() {
      return this.getGlobalDsv()?.formId;
    },
    tableList() {
      const subformList = this.subformList;
      if (subformList) {
        return [{ label: "当前表", name: "mainTable" }].concat(subformList);
      } else {
        return [{ label: "当前表", name: "mainTable" }];
      }
    },
    finalTableFieldList() {
      if (this.searchVal) {
        return this.tableFieldList.filter((item) => item.label.includes(this.searchVal) || item.name.includes(this.searchVal));
      } else {
        return this.tableFieldList;
      }
    },
    inputValue() {
      return this.curComputationalFormula.reduce((prev, item) => (prev += item.value), "");
    }
  },

  mounted() {
    this.getInit();
    console.log(this.optionModel, "ppp");
  },

  methods: {
    updateValue(e) {
      const selection = window.getSelection();
      const index = selection.anchorOffset;
      setTimeout(() => {
        selection.collapse(selection.anchorNode, index);
      });
      this.$nextTick(() => {});
      const val = this.$refs.input.innerHTML;
      console.log(selection, val);
      console.log(val, this.inputValue, index);
      if (this.inputValue.length > val.length) {
        // 退格
        const calcIndex = this.getComputationalFormulaIndex(index);
        this.curComputationalFormula.splice(calcIndex, 1);
      } else {
        // 插入
        const calcIndex = this.getComputationalFormulaIndex(index - 1);
        this.curComputationalFormula.splice(calcIndex, 0, {
          type: "keyboard",
          value: val.charAt(index - 1)
        });
      }
    },
    getComputationalFormulaIndex(inputIndex) {
      let count = 0;
      for (let index = 0; index < this.curComputationalFormula.length; index++) {
        const element = this.curComputationalFormula[index];
        count += `${element.value}`.length;
        console.log(element, count, inputIndex);
        if (count > inputIndex) {
          console.log(index);
          return index;
        }
      }
      return this.curComputationalFormula.length;
    },
    async getInit() {
      const res = await metadataService.querySubformList(this.formId);
      this.subformList =
        res.data.map((e) => {
          return {
            label: e.slaveTableBusinessName || e.slaveTableName,
            name: e.slaveTableName
          };
        }) || [];
    },
    async getcolumnList(tableName) {
      const res = await metadataService.columnList(tableName);
      return (
        res.data
          .filter((item) => item.isInternalField !== 1)
          .map((e) => {
            return {
              label: `${e.columnDisplayName}`,
              name: `${e.columnName}`
            };
          }) || []
      );
    },
    async tableChange(val) {
      console.log(val);
      this.activeTableName = val;
      const calcName = this.optionModel.name.indexOf("-") === -1 ? this.optionModel.name : this.optionModel.name.split("-")[1];
      console.log(calcName, this.optionModel.name, "lll");
      if (val === "mainTable") {
        console.log(this.setFieldList());
        this.tableFieldList = this.setFieldList().filter((item) => item.name !== calcName);
      } else if (this.allSubformList[val]) {
        this.tableFieldList = this.allSubformList[val];
      } else {
        const data = await this.getcolumnList(val);
        this.allSubformList[val] = this.tableFieldList = data.filter((item) => item.name !== calcName);
      }
    },
    empty() {
      this.curComputationalFormula = [];
    },
    backspace() {
      this.curComputationalFormula.pop();
    },
    fieldAction(val) {
      const operate = {
        value: val.label,
        key: val.name,
        type: "field",
        isMianTable: this.activeTableName === "mainTable",
        tableName: this.activeTableName
      };
      this.action(operate);
    },
    action(operate) {
      this.curComputationalFormula.push(operate);
    },
    showComputationalFormulaDialog() {
      console.log("...");
      this.visibleComputationalFormulaDialog = true;
      this.curComputationalFormula = cloneDeep(this.computationalFormula || []);
    },
    close() {
      this.visibleComputationalFormulaDialog = false;
      this.curComputationalFormula = [];
      this.searchVal = "";
      this.tableName = "";
      this.tableFieldList = [];
      this.activeTableName = "";
    },
    async submit() {
      this.optionModel.computationalFormula = cloneDeep(this.curComputationalFormula);
      this.close();
    }
  }
};
</script>

<style lang="less" scoped>
.tableFieldList {
  height: 340px;
  border: 1px solid #f2f2f2;
  overflow: auto;
  margin: 20px 0 0 0;
}
.field {
  border-bottom: 1px solid #f2f2f2;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
}
.curComputationalFormula {
  width: 100%;
  height: 28px;
  border: 1px solid #dcdfe6;
  text-align: center;
}
.green {
  background-color: #67c23a;
  // padding: 0 5px;
  color: #fff;
}
.blue {
  background-color: var(--theme-color);
  color: #fff;
}
.top {
  // height: 100px;
  // line-height: 100px;
  padding: 30px 0;
  width: 100%;
  display: flex;
  align-items: flex-start;
  border: 1px solid #f2f2f2;
  position: relative;
  font-size: 18px;
  span {
    font-size: 18px;
  }
  .equalSign{
    width: 10px;
    line-height: 24px;
  }
  .input {
    font-size: 18px;
    width: 95%;
    // height: 40px;
    line-height: 24px;
    position: absolute;
    top: 30px;
    left: 10px;
    caret-color: #000;
    z-index: 999;
    color: transparent;
    background: transparent;
  }
  .input:focus {
    border: none;
    outline: none;
  }
  .mask {
    font-size: 18px;
    // display: inline-block;
    width: 95%;
    // margin-top: 50px;
    height: 100%;
    line-height: 24px;
    // top: 0px;
    // left: 16px;
  }
}
.operate {
  position: absolute;
  bottom: 1px;
  right: 20px;
}
.radio-group-custom {
  ::v-deep .el-radio-button__inner {
    padding-left: 12px;
    padding-right: 12px;
  }
}
.bottom {
  padding: 10px;
  margin-top: 10px;
  height: 500px;
  display: flex;
  border: 1px solid #f2f2f2;
}
.left {
  border: 1px solid #f2f2f2;
  width: 220px;
  margin-right: 20px;
  padding: 10px;
}
</style>
